import React from 'react';

import { Label, Headline, Disclaimer, Button } from '../../theme';
import { Oven, Fridge } from '../../svg';
import { isMobile } from '../../util';

const OvenSolutions = () => {
  return (
    <div id="CuptorSol" className="container__fluid page__solution">
      {
        !isMobile && (
          <div className="start birds">
            <Oven.Flags />
          </div>
        )
      }
      <div className="w__flex w__flex-column Justify-center Justify-start__mobile">
        <Label
          marginLeft={isMobile ? false : '20vw'}
          background="#840050"
        >
          solutia mamei
        </Label>
        {
          isMobile
            ? <Headline small >
              <p style={{ color: '#d33c64' }}>Vrei temperatura constanta </p>
              <p style={{ color: '#d33c64' }}>si economie? Inchide usa </p>
              <p style={{ color: '#d33c64' }}>cuptorului! Iluminarea </p>
              <p style={{ color: '#d33c64' }}>interioara te ajuta sa vezi </p>
              <p style={{ color: '#d33c64' }}>preparatul.</p>
            </Headline>
            : <Headline padding="20vw" small alignLeft >
              <p style={{ color: '#d33c64' }}>DACA NU DESCHIZI USA CUPTORULUI,</p>
              <p style={{ color: '#d33c64' }}>TEMPERATURA SE MENTINE CONSTANTA </p>
              <p style={{ color: '#d33c64' }}>SI FACI ECONOMIE. IN PLUS, AI BECUL</p>
              <p style={{ color: '#d33c64' }}>ILUMINATOR CARE TE AJUTA SA VEZI</p>
              <p style={{ color: '#d33c64' }}>EVOLUTIA PREPARATULUI.</p>
            </Headline>
        }
        <div className="w__flex Align-right w__flex-column__mobile Align-left__mobile">
          <Disclaimer
            style={{
              paddingLeft: isMobile ? '0' : '20vw'
            }}
          >
            <span>
              Comparativ cu cele din clasa energetica A, <strong>cuptoarele <br className="mobile__hidden" />  din clasa A+ consuma cu 13% mai putina energie electrica.</strong>
          </span>
          </Disclaimer>
          <span>
            <Button arctic to="https://www.arctic.ro/produse-incorporabile/cuptoare.html">
              <span className="mobile__hidden">Vezi</span>  produsele arctic
            </Button>
            {
              isMobile && (
                <Button enel >
                  <span className="mobile__hidden">Vezi</span>  oferta enel
                </Button>
              )
            }
          </span>
        </div>
      </div>
      <div className="end plates">
      {
        isMobile
        ? <Fridge.Kids />
        : <Oven.Ice />
      }
        
      </div>
      {
        !isMobile && (
          <Button enel >
            <span className="mobile__hidden">Vezi</span>  oferta enel
        </Button>
        )
      }
    </div >
  );
};

export default OvenSolutions;


// WEBPACK FOOTER //
// ./src/components/pages/Cuptor/OvenSolutions.jsx